define('tdautotext', ['jquery'], function ($) {

    return {
        input: $('input#search'),
        timeBeforestart: 3000,
        timeToNextChar: 100,
        claimStartAt: 0,
        active: !("tdautotext" in localStorage),
        claims: ["Du suchst es, wir haben es!", "Wer suchet, der findet.", "Die Suche findet nahezu alles.", "Lassen Sie die Suche für Sie arbeiten.", "Alles hat ein Ende. Auch das Suchen!", "Finderlohn in Sekunden - garantiert!"],
        getRandomInt: function getRandomInt() {
            if (this.claimStartAt === this.claims.length) {
                this.claimStartAt = 0;
            }
            return this.claimStartAt;
            //return Math.floor(Math.random() * this.claims.length);
        },
        loopChars: function loopChars() {
            var _this = this;

            if (!!this.active) {
                (function () {
                    _this.input.attr('placeholder', '');
                    _this.currentClaim = _this.claims[_this.getRandomInt()];
                    _this.claimStartAt++;
                    var maxLength = _this.currentClaim.length;

                    var _loop = function _loop(i) {
                        setTimeout(function () {
                            _this.input.attr('placeholder', _this.input.attr('placeholder') + _this.currentClaim[i]);
                            if (i === maxLength - 1) {
                                _this.init();
                            }
                        }, i * _this.timeToNextChar);
                    };

                    for (var i = 0; i < maxLength; i++) {
                        _loop(i);
                    }
                })();
            } else {
                this.input.attr('placeholder', 'Suchen...');
            }
        },
        bindEvents: function bindEvents() {
            var _this2 = this;

            this.input.focus(function () {
                _this2.active = false;
                window.localStorage.setItem('tdautotext', 'false');
            });
        },
        init: function init() {
            var _this3 = this;

            this.bindEvents();
            setTimeout(function () {
                return _this3.loopChars();
            }, this.timeBeforestart);
        }
    };
});

